export enum IPostStatus {
  DRAFT = 'DRAFT',
  PUBLIC = 'PUBLIC',
  ACTIVE = 'ACTIVE',
}

export interface IMediaItem {
  type: 'image' | 'file' | 'video';
  url: string;
  name: string;
  description?: string;
  transcoded?: {
    thumbnail?: string;
    medium?: string;
    high?: string;
    original?: string;
  };
}

export interface IPostCreatedBy {
  userId: string;
  displayName: string;
  avatarUrl?: string;
  role?: string;
}

export interface IMention {
  offset: number;
  length: number;
  key: number;
  profileId: number;
  block: number;
}
